/**
 * The platform admin surface lives on its own host: `platform.` + the main
 * host (PRD; discussion 2026-09-01) — platform.romi.io.vn in prod,
 * platform.localhost in dev. Nothing is hard-coded: only the prefix matters.
 */
export function isPlatformHost(hostname: string = window.location.hostname): boolean {
  return hostname.startsWith('platform.')
}
